import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./Home";
import Contact from "./Contact";
import { Privacy, Terms, Refund } from "./Legal";
import AdminMessages from "./AdminMessages";
import "./App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/refund" element={<Refund />} />
          <Route path="/admin/messages" element={<AdminMessages />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
